<template>
  <div class="convert-phone-container" @click="close">
    <div class="convert-phone-content" @click.stop>
      <div class="title">会员兑换</div>
      <div class="sub-title">会员仅支持充值 1 次，请核对手机号正确无误</div>
      <div class="input-container">
        <input v-model="phone" class="input" type="text" placeholder="请输入手机号码" />
      </div>
      <div class="btn-container flex">
        <div class="btn cancel-btn cursor_p" @click="close">取消</div>
        <div class="btn use-btn cursor_p" @click="convert">兑换</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    tradeNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      phone: ''
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async convert() {
      try {
        const { code, data, message } = await api.account.convertTencentVideoMember({
          phone: this.phone,
          trade_no: this.tradeNo
        })
        if (code === 1000) {
          this.$message.success('兑换成功')
          this.close()
        } else {
          this.$message.error(data?.msg || message)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.convert-phone-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  background-color: rgba($color: #000000, $alpha: 0.6);
  .convert-phone-content {
    width: 524px;
    padding: 24px 32px 28px;
    background: #FFFFFF;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03);
    border-radius: 8px;
    box-sizing: border-box;
    .title {
      font-size: 18px;
      font-weight: 600;
      color: #404040;
    }
    .sub-title {
      margin-top: 16px;
      font-size: 14px;
      color: #606060;
    }
    .input-container {
      width: 100%;
      height: 36px;
      margin-top: 26px;
      border-radius: 2px;
      border: 1px solid #ECECEC;
      position: relative;
      .input {
        width: 100%;
        height: 100%;
        padding: 11px 32px 11px 16px;
        box-sizing: border-box;
        outline: none;
      }
    }
    .btn-container {
      margin-top: 28px;
      width: 100%;
      justify-content: flex-end;
      .btn {
        width: 84px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 2px;
        border: 1px solid #D9D9D9;
        font-size: 14px;
        &:hover {
          opacity: .8;
        }
      }
      .cancel-btn {
        color: #606060;
      }
      .use-btn {
        color: #fff;
        margin-left: 16px;
        background-color: #ff6644;
        border-color: #FF6644;
      }
    }
  }
}
</style>
